import script from "./VideoSupportPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoSupportPage.vue?vue&type=script&setup=true&lang=js"

import "./VideoSupportPage.vue?vue&type=style&index=0&id=6d835eaf&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d835eaf"]])

export default __exports__